export default "__VITE_ASSET__0711b682__"